import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import {
  bourseCategorySelect,
  bourse_select_category_reducer,
} from "./redux/bourse/select_categories";
import {
  bourseMainGroupSelect,
  bourse_select_mainGroup_reducer,
} from "./redux/bourse/select_main_groups";
import {
  bourseSubCategorySelect,
  bourse_select_subCategory_reducer,
} from "./redux/bourse/subCategory";
import {
  bourseInstrumentsSelect,
  bourse_select_instruments_reducer,
} from "./redux/bourse/select_instruments";
import {
  bourse_select_producer_reducer,
  selectProducer,
} from "./redux/bourse/select_producer";
import {
  bourseInstrumentsSelectPdf,
  bourse_select_instruments_pdf_reducer,
} from "./redux/bourse/select_instruments_pdf";
import { newsSelect, news_select_reducer } from "./redux/news/select_news";
import {
  news_select_Attachment_reducer,
  newsSelectAttachment,
} from "./redux/news/news_attachment_select/index";
import { select_shoab_reducer , workerSelectShoab } from "./redux/shoab/select_shoab";
import { select_slider_reducer  , workerSelectSlider} from "./redux/slider/select_slider";
import { reducer_notificationAlert } from "./redux/notificationAlert";
import { reducer_customer_get_kyc_profile , worker_customer_get_kyc_profile } from "./redux/oms/customer_select_get_kyc_profile";
import { reducerSelecOptionStatusCkeckQuestint  , selectOptionStatusCkeckQuestint} from "./redux/questionOption/select_check_questionOption_completion_status";
import { reducerSelecOptionExamt , workerSelectOptionExamt} from "./redux/questionOption/select_online_exam_questionOption";
import { reducer_deceased_customer_get_kyc_profile  , worker_deceased_customer_get_kyc_profile} from "./redux/deceased_customer/deceased_customer_select_get_kyc_profile";
import { select_post_reducer,select_post_worker } from "./redux/post/selectPost";
import { select_check_gift_serial_reducer,select_check_gift_serial_worker } from "./redux/gift/gold/select_check_gift_serial";
import { select_check_state_customer_reducer , select_check_state_customer_worker } from "./redux/gift/gold/check_state_customer";

import { report_trade_detail_reducer , reportTradeDetailWorker } from "./redux/bourse/report_trade_detail";
import { select_commodities_reducer  , bourseSelectCommoditiesWorker} from "./redux/bourse/select_commodities";
import { bourse_select_manufacturer_reducer , bourseSelectManufacturerWorker } from "./redux/bourse/select_manufacturer";


import { reducerSelectInfoRealPdf , workerSelectInfoRealPdf } from "./redux/pdf/select_info_real_pdf";
import { reducerselectOfflineElectronicTransactionsPdf,workerselectOfflineElectronicTransactionsPdf } from "./redux/pdf/select_offline_electronic_transactions_pdf";
import { reducerSelectOnlinePdf , workerSelectOnlinePdf } from "./redux/pdf/select_online_pdf";
import { reducerselectRiskPdf , workerselectRiskPdf } from "./redux/pdf/select_risk_pdf";
import { select_pdf_creator_reducer  , workerselect_pdf_creator} from "./redux/pdf/select_pdf_creator";
import { reducerSelectOptionRealPdf, workerSelectOptionRealPdf } from "./redux/pdf/select_option_real_pdf";
import { reducerSelectSubsidiaryRealPdf , workerSelectSubsidiaryRealPdf } from "./redux/pdf/select_subsidiary_real_pdf";
import { reducerselectComprehensiveContract,workerselectComprehensiveContract } from "./redux/pdf/select_comprehensive_contract";
import { reducerSelecOnlineExamt , workerSelectOnlineExamt } from "./redux/exam_gold/select_online_exam";
import { reducerSelecStatusCkeckQuestint  , selectStatusCkeckQuestint } from "./redux/exam_gold/select_check_questionnaires_completion_status";
import { select_check_state_customer_broker_reducer , select_check_state_customer_broker_worker } from "./redux/deceased_customer/check_state_customer_broker";
import { get_branches_reducer  , get_branches_worker} from "./redux/shoab/getBranches/getBranches";


export const Reducers = combineReducers({
  
  get_branches_reducer,
  select_check_state_customer_broker_reducer,
  reducerSelecStatusCkeckQuestint,
  reducerSelecOnlineExamt,
  reducerselectComprehensiveContract,
  reducerSelectSubsidiaryRealPdf,
  reducerSelectOptionRealPdf,
  select_pdf_creator_reducer,
  reducerselectRiskPdf,
  reducerSelectOnlinePdf,
  reducerselectOfflineElectronicTransactionsPdf,
  reducerSelectInfoRealPdf,
  select_check_state_customer_reducer,
  select_check_gift_serial_reducer,
  select_post_reducer,
  bourse_select_manufacturer_reducer,
  select_commodities_reducer,
  report_trade_detail_reducer,
  reducer_deceased_customer_get_kyc_profile,
  bourse_select_mainGroup_reducer,
  bourse_select_category_reducer,
  bourse_select_subCategory_reducer,
  bourse_select_instruments_reducer,
  bourse_select_producer_reducer,
  bourse_select_instruments_pdf_reducer,
  news_select_reducer,
  news_select_Attachment_reducer,
  select_shoab_reducer,
  select_slider_reducer,
  reducer_notificationAlert,
  reducer_customer_get_kyc_profile ,  
  reducerSelecOptionStatusCkeckQuestint,
  reducerSelecOptionExamt , 
});

export default function* rootSaga() {
  yield all([

    get_branches_worker(),
    select_check_state_customer_broker_worker(),
    selectStatusCkeckQuestint(),
    workerSelectOnlineExamt(),
    workerselectComprehensiveContract(),
    workerSelectSubsidiaryRealPdf(),
    workerSelectOptionRealPdf(),
    workerselect_pdf_creator(),
    workerselectRiskPdf(),
    workerSelectOnlinePdf(),
    workerselectOfflineElectronicTransactionsPdf(),
    workerSelectInfoRealPdf(),
    select_post_worker(),
    bourseSelectCommoditiesWorker(),
    reportTradeDetailWorker(),
    bourseMainGroupSelect(),
    bourseCategorySelect(),
    bourseSubCategorySelect(),
    bourseInstrumentsSelect(),
    selectProducer(),
    bourseInstrumentsSelectPdf(),
    newsSelect(),
    newsSelectAttachment(),
    workerSelectShoab(),
    workerSelectSlider(),
    worker_customer_get_kyc_profile(),
    selectOptionStatusCkeckQuestint(),
    workerSelectOptionExamt(),
    worker_deceased_customer_get_kyc_profile(),
    bourseSelectManufacturerWorker(),
    select_check_gift_serial_worker(),
    select_check_state_customer_worker(),
  ]);
}
